import { useUserStore } from "~/stores/userStore";
const publicPageNames = [
  "login",
  "link-lt-secret",
  "payment-token",
  "campaign-preview",
];

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return;

  const hasToken = localStorage.getItem("sessionToken");

  const page = String(to.name);
  const isPublic = isPublicPage(page);

  if (hasToken) {
    if (isPublic && page !== "payment-token") {
      return navigateTo("/");
    }
  } else {
    if (!isPublic) {
      return navigateTo("/login");
    }

    return;
  }

  const userStore = useUserStore();
  const { $trpc, $amplitude, $clarity } = useNuxtApp();

  let attempt = 0;
  function fetchUser() {
    $trpc.admin.getCurrentUser
      .query()
      .then((user) => {
        userStore.setUser(user);
        if (user.authUserId) {
          $clarity?.identify("spoofing");
          $amplitude?.setUserId("spoofing");
        } else {
          $clarity?.identify(user.id);
          $amplitude?.setUserId(user.id);
        }
      })
      .catch((error) => {
        if (error.message === "UNAUTHORIZED") {
          localStorage.removeItem("sessionToken");
          userStore.user = undefined;
          // navigate to login
          if (!isPublicPage(String(to.name))) {
            navigateTo("/login");
          }
        } else {
          console.error(error); // appinsights todo
          if (attempt > 3) {
            navigateTo("/error");
          } else {
            attempt++;
            fetchUser();
          }
        }
      });
  }
  // not awaiting - if we find out we should redirect to login or error, we can do it,
  // but there is no point delaying navigation and trying to fetch data.
  // We will not load data if user does not have access to it.
  fetchUser();
});

function isPublicPage(pageName: string) {
  return publicPageNames.includes(pageName);
}
